<template>
  <div>
    
    <div class="header">
      <div class="header-top">
        <img class="header-top-img" src="../assets/images/xiu/header_bg_banner.png" alt="" />
        <div class="header-top_test">
          <img src="../assets/images/xiu/header_logo_main.png" class="top_test_l" alt="" srcset="">
          <div class="top_test_r">
            
          <img @click="goSearch()" src="../assets/images/xiu/header_icon_search.png" class="top_test_r_ss" alt="" srcset="">
          </div>
        </div>
      </div>
      <van-overlay :z-index="999999" :show="isQrcodeOverlayVisible" @click="isQrcodeOverlayVisible = false">
        <div class="wrapper" @click.stop>
          <div class="qrcode-wrap">
            <div class="qrcoe-title">甘肃总工会</div>
            <img :src="qrcodeImageSrc" alt="">
            <div class="qrcode-tips ">(长按二维码进行保存)</div>
          </div>
          <div @click="isQrcodeOverlayVisible = false" class="close">
            <van-icon size="36" color="#ffffff" name="close" />
          </div>

        </div>
      </van-overlay>
      <van-popup v-model="isMenuPopupVisible" position="left" :style="{ height: '100%', width: '80%' }">
        <div class="pop">
          <div class="top">
            <van-icon @click="isMenuPopupVisible = false" size="24" color="#c90c0c" name="close" />
            <van-icon @click="$router.push('/search')" size="24" color="#c90c0c" name="search" />
          </div>
          <div class="on">
            <img class="l" src="https://file.gsgh.org.cn/group1/M00/04/3D/CtUSD2awjrWAK14UAAABRUdZUQc554.png" alt="" @click="goBack">
            <div class="c">{{ currentName }}</div>
            <img class="r" src="https://file.gsgh.org.cn/group1/M00/04/3D/CtUSD2awjsKAD5UeAAABh2Qr1Ok117.png" alt="" @click="goToPath">
          </div>
          <div class="matrix">
            <div @click="handleItemClick(item)" v-for="(item,index) in menuList" :key="index" class="item">
              <div class="title">{{item.name}}</div>
              <img v-show="item.children && item.children.length > 0" src="https://file.gsgh.org.cn/group1/M00/04/3E/CtUSD2awltqAdNu5AAABtuKvjtc962.png" alt="">
            </div>
          </div>
          
        </div>
      </van-popup>
    </div>
    <div class="tebel">
      <div class="tebel_c"   ref="scrollableContainer">
        <div class="tebel_lic1" :style="tabContainerStyle">
          <div class="tebel_lic">
            <div class="tebel_li" @click="switchTab(1)" :class="activeTabIndex === 1 ? 'choose' : ''">
              <img class="tebel_img te1" v-if="activeTabIndex === 1" src="@/assets/images/xiu/home/tab_home_active.png" alt="" srcset="">
              <img class="tebel_img te1" v-else src="@/assets/images/xiu/home/tab_home_default.png" alt="" srcset="">
              <span>首页</span>
            </div>
            <div class="tebel_li" @click="switchTab(2)" :class="activeTabIndex === 2 ? 'choose' : ''">
              <img class="tebel_img te2" v-if="activeTabIndex === 2" src="@/assets/images/xiu/home/ab_union_overview_active.png" alt="" srcset="">
              <img class="tebel_img te2" v-else src="@/assets/images/xiu/home/tab_union_overview_default.png" alt="" srcset="">
              <span>工会概况</span>
            </div>
            <div class="tebel_li" @click="switchTab(3)" :class="activeTabIndex === 3 ? 'choose' : ''">
              <img class="tebel_img te2" v-if="activeTabIndex === 3" src="@/assets/images/xiu/home/tab_news_active.png" alt="" srcset="">
              <img class="tebel_img te2" v-else src="@/assets/images/xiu/home/tab_news_default.png" alt="" srcset="">
              <span>新闻资讯</span>
            </div>
            <div class="tebel_li" @click="switchTab(4)" :class="activeTabIndex === 4 ? 'choose' : ''">
              <img class="tebel_img te2" v-if="activeTabIndex === 4" src="@/assets/images/xiu/home/tab_documents_active.png" alt="" srcset="">
              <img class="tebel_img te2" v-else src="@/assets/images/xiu/home/tab_documents_default.png" alt="" srcset="">
              <span>文件资料</span>
            </div>
            <div class="tebel_li" @click="switchTab(6)" :class="activeTabIndex === 6 ? 'choose' : ''">
              <img class="tebel_img te2" v-if="activeTabIndex === 6" src="@/assets/images/xiu/home/tab_model_worker_active.png" alt="" srcset="">
              <img class="tebel_img te2" v-else src="@/assets/images/xiu/home/tab_model_worker_default.png" alt="" srcset="">
              <span>劳模工匠</span>
            </div>
            <div class="tebel_li" @click="switchTab(7)" :class="activeTabIndex === 7 ? 'choose' : ''">
              <img class="tebel_img te2" v-if="activeTabIndex === 7" src="@/assets/images/xiu/home/tab_special_column_active.png" alt="" srcset="">
              <img class="tebel_img te2" v-else src="@/assets/images/xiu/home/tab_special_column_default.png" alt="" srcset="">
              <span>专题专栏</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Popup, Icon, Overlay } from 'vant';
Vue.use(Popup);
Vue.use(Icon);
Vue.use(Overlay);
export default {
  name: "AppHeader",
  data() {
    return {
      // Tab 显示控制：首页、工会概况、新闻资讯、文件资料、劳模工匠、专题专栏
      showHomeTab: true,
      showUnionOverviewTab: true,
      showNewsTab: true,
      showDocumentsTab: true,
      showModelWorkerTab: false,
      showSpecialColumnTab: false,
      // Tab 滚动位置状态：0-初始位置，1-中间位置，2-右侧位置
      tabScrollState: 0,
      menuList :[
        {
          name: "首页",
          isChild : false,
          path: "/"
        },
        {
          name: "工会概况",
          children :[
            {
              name: "省总简介",
              isChild : false,
              path: "/newsList?categoryId=50601&title=省总简介"
            },
            {
              name: "主要职责",
              isChild : false,
              path: "/newsList?categoryId=50604&title=主要职责"
            },
            {
              name: "省总领导",
              isChild : false,
              path: "/newsList?categoryId=50602&title=省总领导"
            },
            {
              name: "组织机构",
              isChild : false,
              path: "/newsList?categoryId=50603&title=组织机构"
            },
          ],
          isChild : true,
          path: ""
        },
        {
          name: "新闻资讯",
          isChild : false,
          children :[
            {
              name: "时政要闻",
              isChild : false,
              path: "/newsList?categoryId=502&title=时政要闻"
            },
            {
              name: "工会要闻",
              isChild : false,
              path: "/newsList?categoryId=502&title=工会要闻"
            },
            {
              name: "工作动态",
              isChild : false,
              path: "/newsList?categoryId=501&title=工作动态"
            },
            {
              name: "通知公告",
              isChild : false,
              path: "/newsList?categoryId=505&title=通知公告"
            },
          ],
          path: ""
        },
        {
          name: "文件资料",
          isChild : true,
          children :[
            {
              name: "领导讲话",
              isChild : false,
              path: "/newsList?categoryId=50301&title=领导讲话"
            },
            {
              name: "法律法规",
              isChild : false,
              path: "/newsList?categoryId=50304&title=法律法规"
            },
            {
              name: "政策文件",
              isChild : false,
              path: "/newsList?categoryId=50305&title=政策文件"
            },
            {
              name: "在线读报",
              isChild : false,
              path: "/newsList?categoryId=50306&title=在线读报"
            },
          ],
          path: ""
        },
        // {
        //   name: "工会服务",
        //   isChild : false,
        //   path: "/service"
        // },
        {
          name: "劳模工匠",
          isChild : false,
          path: "/lmList"
        },
        {
          name: "专题专栏",
          isChild : false,
          path: "/ztList"
        }
      ],
      historyStack: [],
      currentName: '首页',
      currentPath: '/',
      isMenuPopupVisible: false,
      isQrcodeOverlayVisible: false,
      qrcodeImageSrc: "",
      activeTabIndex: 1,
      tabContainerStyle: {
        marginLeft: ''
      }
    };
  },
  
  activated() {
    const routePath = this.$route.fullPath;
    
    // 路由路径到 Tab 配置的映射
    const routeConfigMap = {
      '/index': {
        tabIndex: 1,
        scrollState: 0,
        tabs: [true, true, true, true, true, true],
        needScroll: false
      },
      '/unionOverview': {
        tabIndex: 2,
        scrollState: 0,
        tabs: [true, true, true, true, false, false],
        needScroll: false
      },
      '/moreNews': {
        tabIndex: 3,
        scrollState: 0,
        tabs: [true, true, true, true, false, false],
        needScroll: false
      },
      '/staffArtsMore': {
        tabIndex: 3,
        scrollState: 0,
        tabs: [true, true, true, true, false, false],
        needScroll: false
      },
      '/documentation': {
        tabIndex: 4,
        scrollState: 0,
        tabs: [true, true, true, true, false, false],
        needScroll: false
      },
      '/lmList': {
        tabIndex: 6,
        scrollState: 1,
        tabs: [false, false, true, true, true, true],
        needScroll: true
      },
      '/specialColumn': {
        tabIndex: 7,
        scrollState: 2,
        tabs: [false, false, true, true, true, true],
        needScroll: true
      }
    };
    
    const config = routeConfigMap[routePath];
    if (config) {
      this.activeTabIndex = config.tabIndex;
      this.tabScrollState = config.scrollState;
      this.setTabVisibility(...config.tabs);
      
      // 需要滚动的情况
      if (config.needScroll) {
        this.$nextTick(() => {
          const scrollableContainer = this.$refs.scrollableContainer;
          if (scrollableContainer) {
            scrollableContainer.scrollLeft = 200;
          }
        });
      }
    }
  },
  methods: {
    /**
     * 处理 Tab 导航栏左右滚动按钮点击
     * @param {number} direction - 1: 向左滚动, 2: 向右滚动
     */
    handleTabScroll(direction) {
      if (direction === 1) {
        // 向左滚动
        if (this.tabScrollState === 1) {
          this.tabScrollState = 0;
          this.setTabVisibility(true, true, true, true, false, false);
        } else if (this.tabScrollState === 2) {
          this.tabScrollState = 1;
          this.setTabVisibility(false, true, true, true, true, false);
        } else if (this.tabScrollState === 3) {
          this.tabScrollState = 2;
          this.setTabVisibility(false, false, true, true, true, true);
        }
      } else if (direction === 2) {
        // 向右滚动
        if (this.tabScrollState === 0) {
          this.tabScrollState = 1;
          this.setTabVisibility(false, true, true, true, true, false);
        } else if (this.tabScrollState === 1) {
          this.tabScrollState = 2;
          this.setTabVisibility(false, false, true, true, true, true);
        }
      }
    },
    /**
     * 设置 Tab 显示状态
     * @param {boolean} home - 首页
     * @param {boolean} unionOverview - 工会概况
     * @param {boolean} news - 新闻资讯
     * @param {boolean} documents - 文件资料
     * @param {boolean} modelWorker - 劳模工匠
     * @param {boolean} specialColumn - 专题专栏
     */
    setTabVisibility(home, unionOverview, news, documents, modelWorker, specialColumn) {
      this.showHomeTab = home;
      this.showUnionOverviewTab = unionOverview;
      this.showNewsTab = news;
      this.showDocumentsTab = documents;
      this.showModelWorkerTab = modelWorker;
      this.showSpecialColumnTab = specialColumn;
    },
    /**
     * 切换到指定的 Tab
     * @param {number} tabIndex - Tab 索引：1-首页, 2-工会概况, 3-新闻资讯, 4-文件资料, 6-劳模工匠, 7-专题专栏
     */
    switchTab(tabIndex) {
      this.activeTabIndex = tabIndex;
      
      // Tab 索引到路由路径的映射
      const tabRouteMap = {
        1: '/index',
        2: 'unionOverview',
        3: 'moreNews',
        4: 'documentation',
        6: 'lmList',
        7: 'specialColumn'
      };
      
      const routePath = tabRouteMap[tabIndex];
      if (routePath) {
        this.$router.push({ path: routePath });
      }
    },
    handleItemClick(item) {
      if (item.children && item.children.length > 0) {
        this.historyStack.push(this.menuList);
        this.menuList = item.children;
        this.currentName = item.name;
      } else {
        this.$router.push(item.path);
        this.isMenuPopupVisible = false; 
      }
    },
    goBack() {
      if (this.historyStack.length > 0) {
        this.menuList = this.historyStack.pop(); 
        this.currentName = this.menuList.length > 0 ? this.menuList[0].name : '首页';
      }
    },
    goToPath() {
      this.$router.push(this.currentPath);
    },
    /**
     * 打开菜单弹窗
     */
    openMenuPopup() {
      this.isMenuPopupVisible = true
    },
    /**
     * 打开二维码遮罩层
     * @param {number} type - 二维码类型：1-微信, 2-其他
     */
    openQrcodeOverlay(type) {
      this.qrcodeImageSrc = type === 1 
        ? require('@/assets/images/footer/w1.jpg')
        : require('@/assets/images/footer/w2.jpg');
      this.isQrcodeOverlayVisible = true
  
    },
    goSearch() {
      this.$router.push("/search");
    },
  },
};


</script>
<style scoped lang="scss">
.header {
  width: 100%;
  height: 100px;
  background: #c90c0c;
  border-radius: 0px 0px 0px 0px;
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  .header-top{
  padding-top:10px ;
    width: 100%;
    height: 100%;
    position: relative;
    .header-top-img{
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      display: block;
      z-index: 2;
    }
    .header-top_test{
      position: relative;
      z-index: 3;
      width: 100%;
      height: 100%;
      .top_test_l{
        float: left;
        width: 349.72px;
        height: 73px;
        display: block;
        margin-left:30px ;
      }
      .top_test_r{
        float: right;
        padding: 10px 28px 0 0;
        .top_test_r_ss{
          float: left;
          display: block;
          width: 48px;
          height: 48px;
          margin-right: 32px;
        }
        .top_test_r_cd  {
          float: left;
          display: block;
          width: 48px;
          height: 48px;
        }
      }
    }

  }
  .header-bg {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-size: 32px;
    font-weight: bold;

    .header-left {
      width: 55%;
      display: flex;
      justify-content: space-around;
      align-items: center;

      img {
        margin-left: -15px;
      }

      span {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #ffffff;
        line-height: 42px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }

    .header-right {
      width: 35%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }

    img {
      width: 48px;
      height: 48px;
    }
  }

  .wrapper {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    .qrcode-wrap {
      position: relative;
      width: 68.6667vw;
      background: #fff;
      border-radius: 8px;
      padding: 2.6667vw 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .qrcoe-title {
        margin: 0 0 1.3333vw 0;
        font-size: 4.2667vw;
        color: #333;
        text-align: center;
        font-weight: 400;
      }

      img {
        width: 63.3333vw;
        height: 63.3333vw;
        margin-bottom: 1.3333vw;
      }

      .qrcode-tips {
        text-align: center;
        font-size: 3.4667vw;
        color: #7c8084;
      }

    }

    .close {
      margin-top: 8px;
      z-index: 999999;
    }
  }

  .pop {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;

    .top {
      margin-top: 20px;
      padding: 20px;
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .on {
      width: 100%;
      height: 80px;
      display: flex;
      padding: 0 25px;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #E3E3E3;

      .l {
        width: 18px;
        height: 20px;
      }

      .c {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        color: #BA0710;
        letter-spacing: 1px;
        width: 80%;
        text-align: left;
      }

      .r {
        width: 40px;
        height: 40px;
      }
    }

    .matrix {
      width: 100%;
      height: fit-content;
      display: flex;
      padding: 0 25px;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;

      .item {
        width: 100%;
        height: 100px;
        display: flex;
        margin-left: 30px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        color: #999999;
        letter-spacing: 1px;
        justify-content: flex-start;
        align-items: center;
        img {
          margin-left: 10px;
          width: 20px;
          height: 20px;
        
        }

      }
    }




  }


}
.tebel{
  overflow: hidden;
  background: #AF1C2E;
  height: 76px;
  padding-top:14px ;
  .tebel_l{
    float: left;
    padding: 20px 0 0 10px;
    margin-right: 20px;
    .tebel_img{
      width: 11px;
      height: 20px;
      display: block;
    }
  }
  .tebel_c{
    float: left;
    width:100%;
    height: 62px;
      overflow-y: hidden;
    .tebel_lic1{
      width:1050px;
    }
    .tebel_lic{
      float: left;
    }
    .tebel_li{
      width: 171px;
      height: 60px;
      // background: #FFFFFF;
      border-radius: 8px 8px 0px 0px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #FFFFFF;
      line-height: 60px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      display: flex;
      align-items: center;
      float: left;
      .tebel_img{
        // display: inline-block;
        width: 30px;
        height: 30px;
        margin-right: 6px;
        margin-top: -3px;
      }


      .te1{
        margin-left: 40px;
      }
      .te2{
        margin-left: 10px;
      }
    }
    .choose{
      background: #fff;
      color: #E51206;
    }



  }
  .tebel_r{
    padding: 20px 10px 0 0 ;
    float: right;
    .tebel_img{
      width: 11px;
      height: 20px;
      display: block;
    }
  }
}
</style>